<template>
  <div>
    <div class="container">
      <div class="themes-thumbnails row">
        <loader :show-loader="loading"></loader>
        <div v-show="!loading" v-for="(productsCategory, category) in products">
          <template v-if="productsCategory.length > 0">
            <div class="row">
              <title-divider :title="category"/>
            </div>
            <div class="row">
              <div v-for="product in productsCategory"
                   class=" col-sm-12 col-md-4 mt-10 data-list-component">
                <card-horizontal :bundle="product"></card-horizontal>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CardHorizontal from './CardHorizontal.vue';

  export default {
    name: 'list-promotions',

    props: {
      products: {},
    },

    components: {
      CardHorizontal,
    },

    mounted() {
      this.stopLoading();
    },

    data: function () {
      return {
        fetchUrl: '',
        loading: true,
      };
    },

    methods: {
      stopLoading: _.debounce(function() {
        this.loading = false
      }, 1000),
    },
  };
</script>
<style scoped>
  @media (min-width: 768px) {
    .data-list-component {
      height: 300px;
    }
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/store/components/ListPromotions.vue